import React, { useEffect, useState } from "react";
import {
  Breadcrumb,
  Button,
  Card,
  Dropdown,
  Layout,
  Menu,
  Modal,
  Space,
  theme,
  Avatar,
  Divider,
} from "antd";
import SideMenu from "./SideMenu";
import ContentBody from "./ContentBody";
import {
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UserOutlined,
  SettingOutlined,
  HomeOutlined,
} from "@ant-design/icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Login from "../Pages/Auth/Login";
import dayjs from "dayjs";
import "dayjs/locale/fr";
// dayjs.locale("fr");

import { api_DisplayName } from "../Services/Constantes";

const { Header, Content, Footer, Sider } = Layout;

// Configuration du menu pour le breadcrumb
const menuItems = [
  {
    label: 'Tableau de Bord',
    key: '/dashboard',
    path: '/dashboard',
  },
  {
    label: 'Fichiers',
    key: 'structure',
    children: [
      { label: 'Données de Base', key: '/donnees_bases', path: '/donnees_bases' },
      { label: 'Adhérents', key: '/adherents', path: '/adherents' },
      { label: 'Fournisseurs de Soins', key: '/fournisseurs', path: '/fournisseurs' },
      { label: 'Participants', key: '/participants', path: '/participants' }
    ]
  },
  {
    label: 'Paramètres',
    key: 'params',
    children: [
      { label: 'Taux de Prise en Charge', key: '/tauxpc', path: '/tauxpc' },
      { label: 'Utilisateurs', key: '/users', path: '/users' },
      { label: "Informations Générales", key: "/informations", path: "/informations" },
    ]
  },
  {
    label: 'Documents',
    key: 'docs',
    children: [
      { label: 'Bons de Pharmacies', key: '/bons_pharmacies', path: '/bons_pharmacies' },
      { label: 'Lettres de Garantie', key: '/lettres_garanties', path: '/lettres_garanties' },
      { label: 'Bons Optiques', key: '/bons_optiques', path: '/bons_optiques' },
      { label: 'Lettres Hospitalisation', key: '/lg_hospitalisation', path: '/lg_hospitalisation' },
    ]
  },
  {
    label: 'Extra - Documents',
    key: 'extradocs',
    children: [
      { label: "Ordres de Paiement", key: "/ordre_paiement", path: "/ordre_paiement" },
      { label: "Bons d'Achat", key: "/bon_achat", path: "/bon_achat" },
      { label: "Factures Adhérents", key: "/Facture_Adherent", path: "/Facture_Adherent" }
    ]
  },
  {
    label: 'Traitements - Saisies',
    key: 'process',
    children: [
      { label: 'Factures Fournisseurs', key: '/factures', path: '/factures' },
      { label: 'Réglement Factures', key: '/reglements', path: '/reglements' },
      { label: 'Saisie Encaissement', key: '/saisie_encaissement', path: '/saisie_encaissement' },
      { label: 'Saisie Cotisations', key: '/cotisations', path: '/cotisations' },
      { label: 'Saisie Journal', key: '/saisie_journal', path: '/saisie_journal' },
      { label: 'Retenues Frais Médicaux', key: '/retenues', path: '/retenues' },
      { label: 'Remb. Frais Médicaux', key: '/remboursements', path: '/remboursements' },
      { label: 'Suspensions', key: '/suspensions', path: '/suspensions' },
    ]
  },
  {
    label: 'Comptabilité',
    key: 'compta',
    children: [
      { label: 'Journal Central', key: '/journal-central', path: '/journal-central' },
      { label: 'Plan Comptable', key: '/plancompta', path: '/plancompta' },
      { label: 'Interrogations Comptes', key: '/interrogation_compte', path: '/interrogation_compte' },
      { label: 'Etat Compta & Fin', key: '/etat_comptafin', path: '/etat_comptafin' }
    ]
  },
  {
    label: 'Extra - Compta',
    key: 'extra',
    children: [
      { label: 'Rapp. Bancaires', key: '/rapport_banque', path: '/rapport_banque' },
      { label: 'Immobilisations', key: '/immobilisation', path: '/immobilisation' },
      { label: 'Prévision Budget', key: '/budget', path: '/budget' },
      { label: 'Reporting & Export', key: '/reporting', path: '/reporting' }
    ]
  },
  {
    label: 'Paie et RH',
    key: 'paie',
    children: [
      { label: 'Gestion Paie', key: '/gestion-paie', path: '/gestion-paie' },
    ]
  },
  {
    label: "Textes et Réglements",
    key: '/text&reglement',
    path: '/text&reglement',
  },
];

// Fonction pour trouver le breadcrumb basé sur le path actuel
const getBreadcrumbItems = (pathname, rolename) => {
  const breadcrumbItems = [];

  // Ajouter l'accueil uniquement si pas Point Focal
  if (rolename !== 'Point Focal') {
    breadcrumbItems.push({
      title: (
        <Link
          to="/dashboard"
          style={{ display: 'flex', alignItems: 'center', gap: 6 }}
          onClick={() => {
            // Fermer tous les menus ouverts et sélectionner Dashboard
            window.dispatchEvent(new CustomEvent('selectMenuItem', { detail: { key: 'dashboard' } }));
          }}
        >
          <HomeOutlined />
          <span>Accueil</span>
        </Link>
      ),
    });
  }

  // Gérer les cas spéciaux (edit, view, show)
  const pathParts = pathname.split('/').filter(p => p);

  // Cas : /participants/edit/:numcont ou /participants/view/:numcont
  if (pathParts.length >= 2 && (pathParts[1] === 'edit' || pathParts[1] === 'view')) {
    const basePath = `/${pathParts[0]}`;

    // Trouver le menu parent et l'item correspondant
    for (const item of menuItems) {
      if (item.children) {
        for (const child of item.children) {
          if (child.path === basePath) {
            // Ajouter le menu parent
            breadcrumbItems.push({
              title: <span style={{ color: '#8c8c8c' }}>{item.label}</span>,
            });
            // Ajouter la page de base
            breadcrumbItems.push({
              title: <Link to={basePath} style={{ color: '#8c8c8c' }}>{child.label}</Link>,
            });
            // Ajouter l'action (Modifier ou Voir)
            breadcrumbItems.push({
              title: <span style={{ color: '#1890ff', fontWeight: 500 }}>
                {pathParts[1] === 'edit' ? 'Modifier' : 'Détails'}
              </span>,
            });
            return breadcrumbItems;
          }
        }
      }
    }
  }

  // Cas : /fournisseurs/edit/:numFourn ou /fournisseurs/view/:numFourn
  if (pathParts.length >= 2 && pathParts[0] === 'fournisseurs' && (pathParts[1] === 'edit' || pathParts[1] === 'view')) {
    const basePath = '/fournisseurs';

    for (const item of menuItems) {
      if (item.children) {
        for (const child of item.children) {
          if (child.path === basePath) {
            breadcrumbItems.push({
              title: <span style={{ color: '#8c8c8c' }}>{item.label}</span>,
            });
            breadcrumbItems.push({
              title: <Link to={basePath} style={{ color: '#8c8c8c' }}>{child.label}</Link>,
            });
            breadcrumbItems.push({
              title: <span style={{ color: '#1890ff', fontWeight: 500 }}>
                {pathParts[1] === 'edit' ? 'Modifier' : 'Détails'}
              </span>,
            });
            return breadcrumbItems;
          }
        }
      }
    }
  }

  // Cas : /factures/show/:numenreg
  if (pathParts.length >= 2 && pathParts[0] === 'factures' && pathParts[1] === 'show') {
    const basePath = '/factures';

    for (const item of menuItems) {
      if (item.children) {
        for (const child of item.children) {
          if (child.path === basePath) {
            breadcrumbItems.push({
              title: <span style={{ color: '#8c8c8c' }}>{item.label}</span>,
            });
            breadcrumbItems.push({
              title: <Link to={basePath} style={{ color: '#8c8c8c' }}>{child.label}</Link>,
            });
            breadcrumbItems.push({
              title: <span style={{ color: '#1890ff', fontWeight: 500 }}>Traitement</span>,
            });
            return breadcrumbItems;
          }
        }
      }
    }
  }

  // Cas : /gestion-paie/edit/:numbull
  if (pathParts.length >= 2 && pathParts[0] === 'gestion-paie' && pathParts[1] === 'edit') {
    const basePath = '/gestion-paie';

    for (const item of menuItems) {
      if (item.children) {
        for (const child of item.children) {
          if (child.path === basePath) {
            breadcrumbItems.push({
              title: <span style={{ color: '#8c8c8c' }}>{item.label}</span>,
            });
            breadcrumbItems.push({
              title: <Link to={basePath} style={{ color: '#8c8c8c' }}>{child.label}</Link>,
            });
            breadcrumbItems.push({
              title: <span style={{ color: '#1890ff', fontWeight: 500 }}>Modifier</span>,
            });
            return breadcrumbItems;
          }
        }
      }
    }
  }

  // Chercher dans les menu items (cas normal)
  for (const item of menuItems) {
    // Vérifier si c'est un item sans enfants
    if (item.path === pathname) {
      breadcrumbItems.push({
        title: <span style={{ color: '#1890ff', fontWeight: 500 }}>{item.label}</span>,
      });
      return breadcrumbItems;
    }

    // Vérifier dans les enfants
    if (item.children) {
      for (const child of item.children) {
        if (child.path === pathname) {
          breadcrumbItems.push({
            title: <span style={{ color: '#8c8c8c' }}>{item.label}</span>,
          });
          breadcrumbItems.push({
            title: <span style={{ color: '#1890ff', fontWeight: 500 }}>{child.label}</span>,
          });
          return breadcrumbItems;
        }
      }
    }
  }

  return breadcrumbItems;
};


const LayoutComp = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [username, setUsername] = useState("");
  const [rolename, setRolename] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const location = useLocation();

  const navigate = useNavigate();

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const handlepagemdp = () => {
    navigate(`/profil`);
  };

  useEffect(() => {
    const storedUsername = localStorage.getItem("username");
    if (storedUsername) {
      setUsername(storedUsername);
    }
  }, []);

  useEffect(() => {
    const storedRolename = localStorage.getItem("role_name");
    if (storedRolename) {
      setRolename(storedRolename);
    }
  }, []);

  // Rediriger automatiquement les utilisateurs "Point Focal" vers le 1er sous-menu
  useEffect(() => {
    if (rolename === 'Point Focal') {
      const currentPath = location.pathname;
      if (currentPath === '/' || currentPath === '/dashboard' || currentPath === '/docs') {
        navigate('/bons_pharmacies', { replace: true });
      }
    }
  }, [rolename, location.pathname, navigate]);


  useEffect(() => {
    let logoutTimer;
    let lastActivityTime = Date.now();

    const sessionTimeout = parseInt(
      localStorage.getItem("sessionDuration") || "1800000",  // 30 minutes
      10
    );

    const resetTimer = () => {
      // Réinitialiser le temps de la dernière activité
      lastActivityTime = Date.now();

      // Annuler le timer précédent
      clearTimeout(logoutTimer);

      // Redémarrer le timer d'inactivité
      if (!isModalVisible) {
        logoutTimer = setTimeout(() => {
          // Vérifier que l'utilisateur est vraiment inactif
          const timeSinceLastActivity = Date.now() - lastActivityTime;
          if (timeSinceLastActivity >= sessionTimeout) {
            showLogoutModal();
          }
        }, sessionTimeout);
      }
    };

    const showLogoutModal = () => {
      if (isModalVisible) return; // Éviter les doublons

      setIsModalVisible(true);
      Modal.confirm({
        title: "Votre session est terminée",
        content: "Pour continuer à utiliser l'application, veuillez vous déconnecter puis vous reconnecter.",
        okText: "Se Déconnecter",
        onOk: () => {
          localStorage.removeItem("auth");
          localStorage.removeItem("user_connect");
          setIsModalVisible(false);
          navigate("/login");
          window.location.reload(true);
          return <Login />;
        },
        cancelButtonProps: { style: { display: "none" } },
        onCancel: () => {
          // Si l'utilisateur annule, réinitialiser l'activité
          setIsModalVisible(false);
          lastActivityTime = Date.now();
          resetTimer();
        },
      });
    };

    // Ajouter des écouteurs d'événements pour réinitialiser le timer
    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keydown", resetTimer);
    window.addEventListener("click", resetTimer);

    // Initialiser le timer
    resetTimer();

    return () => {
      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keydown", resetTimer);
      window.removeEventListener("click", resetTimer);
      clearTimeout(logoutTimer);
    };
  }, [isModalVisible, navigate]);


  const logout = () => {
    Modal.confirm({
      title: "Déconnexion",
      content: "Voulez-vous vraiment quitter l'application?",
      okText: "Oui",
      okType: "danger",
      cancelText: "Annuler",
      centered: true,
      onOk: () => {
        localStorage.clear();
        navigate("/login");
        window.location.reload(true);
        return (<Login />);

      },
    });
  };

  const gestionMenu = (
    <div
      style={{
        background: "#fff",
        borderRadius: 12,
        boxShadow:
          "0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05)",
        padding: 0,
        minWidth: 240,
        overflow: "hidden",
      }}
    >
      {/* Header moderne avec avatar et infos utilisateur */}
      <div
        style={{
          padding: "12px 16px",
          borderBottom: "1px solid #f0f0f0",
          display: "flex",
          alignItems: "center",
          gap: 12,
          background: "linear-gradient(135deg, #fafafa 0%, #ffffff 100%)",
        }}
      >
        <Avatar
          size={42}
          style={{
            background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
            fontSize: 18,
            fontWeight: 600,
          }}
        >
          {username ? username.charAt(0).toUpperCase() : "U"}
        </Avatar>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div
            style={{
              fontWeight: 600,
              fontSize: 14,
              color: "#1f1f1f",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {username || "Utilisateur"}
          </div>
          <div
            style={{
              display: "inline-block",
              marginTop: 4,
              fontSize: 11,
              color: "#595959",
              background: "#f5f5f5",
              borderRadius: 12,
              padding: "2px 8px",
            }}
          >
            {rolename || "Rôle non défini"}
          </div>
        </div>
      </div>

      {/* Options via Menu Ant Design */}
      <Menu
        selectable={false}
        mode="inline"
        onClick={({ key }) => {
          if (key === "profile") handlepagemdp();
          if (key === "logout") logout();
        }}
        items={[
          {
            key: "profile",
            icon: <SettingOutlined />,
            label: <span style={{ fontSize: 14 }}>Mon Profil</span>,
          },
          { type: "divider" },
          {
            key: "logout",
            icon: <LogoutOutlined />,
            danger: true,
            label: <span style={{ fontSize: 14 }}>Déconnexion</span>,
          },
        ]}
        style={{ border: "none", padding: 8 }}
      />
    </div>
  );

  dayjs.locale("fr");
  // Générer la date du jour au format demandé
  const dateDuJour = `Nous sommes le ${dayjs().format("dddd D MMMM YYYY")}`;


  return (
    <Layout style={{ minHeight: "100vh" }}>
      {/* Header est en haut, à 100% de la largeur */}
      <Header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          background: "#053f14",
          padding: 0,
          height: "50px",
          background: colorBgContainer,
          width: "100%",
        }}
      >
        <Space >
          {/* Ajout de l'image dans le Header */}
          <div style={{ display: "flex", alignItems: "center", }}>
            <img
              src={`/logo-lamps.png`}
              alt="Logo"
              style={{ padding: 10, width: "100px", marginRight: "16px" }}
            />

          </div>
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{
              fontSize: "12px",
              width: "64px",
              height: "64px",
              backgroundColor: "transparent",
              border: "none",
              color: "black",
              cursor: "pointer",
            }}
          />


        </Space>

        {/* Date du jour au centre */}

        <div style={{ flex: 1, textAlign: "center", color: "#053f14", fontWeight: 600, fontSize: 16 }}>
          {dateDuJour.charAt(0).toUpperCase() + dateDuJour.slice(1)}
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            paddingRight: "12px",
          }}
        >
          {/*   <div style={{ color: "black", fontSize: "15px" }}>
            <strong>
              {
                <Dropdown overlay={gestionMenu} trigger={["click"]}>
                  <UserOutlined />
                </Dropdown>
              }
              &nbsp;{username}({rolename})
            </strong>
          </div> */}
          <Dropdown
            overlay={gestionMenu}
            trigger={["click"]}
            placement="bottomRight"
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                padding: "6px 12px",
                borderRadius: 8,
                cursor: "pointer",
                transition: "all 0.2s ease",
                background: "transparent",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "rgba(0, 0, 0, 0.04)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "transparent";
              }}
            >
              <Avatar
                size={32}
                style={{
                  background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
                  fontSize: 14,
                  fontWeight: 600,
                }}
              >
                {username ? username.charAt(0).toUpperCase() : "U"}
              </Avatar>
              <div style={{ lineHeight: 1.2 }}>
                <div style={{ fontWeight: 600, fontSize: 13, color: "#1f1f1f" }}>
                  {username || "Utilisateur"}
                </div>
                <div style={{ fontSize: 11, color: "#8c8c8c" }}>
                  {rolename || ""}
                </div>
              </div>
            </div>
          </Dropdown>

        </div>
      </Header>

      {/* Sider, Content et Footer sont contenus dans le Layout principal */}
      <Layout>
        <Sider trigger={null} collapsible collapsed={collapsed} width={260}  /* style={{ background: "#053f14" }} */ >
          <div
            style={{
              color: "white",
              textAlign: "center",
              marginTop: 12,
              fontSize: "16px",

            }}>
            <strong style={{ color: "whitesmoke", }}>{api_DisplayName}</strong>
          </div>
          <SideMenu />
        </Sider>

        <Layout>
          <div
            style={{
              margin: "5px 0",
              padding: "8px 16px",
              background: "#fff",
              borderRadius: 8,
              boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.03), 0 1px 6px -1px rgba(0, 0, 0, 0.02)",
            }}
          >
            <Breadcrumb
              items={getBreadcrumbItems(location.pathname, rolename)}
              separator="/"
              style={{
                fontSize: 14,
              }}
            />
          </div>
          <Content
            style={{
              margin: "12px 8px 0",
            }}
          >
            <Card
            /*  style={{
               padding: 0,
               minHeight: 360,
               background: colorBgContainer,
             }} */
            >
              <ContentBody />
            </Card>
          </Content>
          <Footer
            style={{
              textAlign: "center",
            }}
          >
            WebLamps © V2 - 2025 Created by A2SMI
          </Footer>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default LayoutComp;
